<template>
    <div class="flags-list-component bg-white rounded-lg overflow-hidden relative">
        <div class="border-b border-gray-300 py-3 px-4">
            <p class="text-lg font-bold">Flags & Alerts List</p>
            <p class="text-sm">The list below containts the flags and alerts triggered under this building.</p>
        </div>
        <div>
            <div
                v-for="(flag, index) in flags"
                :key="`flag-item-${index}`"
                :class="`py-3 px-4 text-sm ${index % 2 ? 'bg-blue-50' : 'bg-blue-100'}`"
            >
                <div class="mb-1">
                    <p><span class="font-bold">Reporting Year:</span> {{ flag.reporting_year }}</p>
                </div>
                <div class="mb-1 capitalize">
                    <p><span class="font-bold">Category:</span> {{ flag.category }}</p>
                </div>
                <div>
                    <p class="font-bold">Message:</p>
                    <p>{{ flag.message }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {

    props: {
        flags: {
            type: Array,
            default: () => []
        }
    }

};

</script>
